import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import FilterBar from './filterBar';
import CampaignsTable from './campaignsTable';
import { getAllCampaigns, getCampaignIngestion } from '../../../redux/thunks/campaignThunks';
import { getPartnerConnections } from '../../../redux/thunks/partnerThunk';
import routeNames from '../../../routes/routeNames';
import { CompanyUserBasedTabs } from '../../sidebar/constants';

const Campaigns = (props) => {
    const {} = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { company: selectedCompany } = useSelector((state) => state.company);
    const {
        userDetails: {
            is_admin, is_staff = 0, email, company: userCompany 
        } 
    } = useSelector((state) => state.user);

    useEffect(()=> {
        const matchingTab = CompanyUserBasedTabs.find(tab => tab.company === selectedCompany.id && tab.user === email);
        if(is_staff && userCompany?.id !== selectedCompany?.id && !matchingTab){
            navigate(routeNames.DASHBOARD);
        } else if (selectedCompany.id) {
            dispatch(getAllCampaigns({ companyId: selectedCompany.id }));
            dispatch(getCampaignIngestion({ companyId: selectedCompany.id }));
            dispatch(getPartnerConnections({ companyId: selectedCompany.id }));
        }
    }, [selectedCompany]);

    return (
        <>
            <FilterBar />
            {/*  */}
            <Grid container spacing={2}>
                {/* Queries Table */}
                <Grid item xs={12}>
                    <CampaignsTable />
                </Grid>
              
            </Grid>
        </>
    );
};

export default Campaigns;